import { render, staticRenderFns } from "./ContactFilter.vue?vue&type=template&id=5896b6ce&"
import script from "./ContactFilter.vue?vue&type=script&lang=js&"
export * from "./ContactFilter.vue?vue&type=script&lang=js&"
import style0 from "./ContactFilter.vue?vue&type=style&index=0&id=5896b6ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports